import Arabic from "assets/countryFlagsImages/english-arabic.svg";
import Chinese from "assets/countryFlagsImages/english-arabic.svg";
import German from "assets/countryFlagsImages/english-arabic.svg";
import Spanish from "assets/countryFlagsImages/english-arabic.svg";
import Swedish from "assets/countryFlagsImages/english-arabic.svg";

import Notarized from "assets/countryFlagsImages/notarized.svg";
import Death from "assets/countryFlagsImages/deathcertif.svg";
import Birth from "assets/countryFlagsImages/birthcertif.svg";
import Certificate from "assets/countryFlagsImages/certificate.svg";
import Patent from "assets/countryFlagsImages/patent.svg";

export const LegalTransData = [
  {
    heading: "Professional Legal Translation Services by Experts",
    para: "Tomedes commands a global team of expert linguists, in over 100 countries and on every continent. These legal translators are familiar with the terminology, format, and structure of legal documents and the requirements for their preparation, presentation and submission to various jurisdictions. These linguistic specialists are skilled in the language of the law as used in virtually any jurisdiction in the world.",
    img_link: "",
  },
  {
    heading: "Certified Legal Translation Services",
    para: "Most courts require that legal translations be done by a qualified and certified translator. Only a translator with the required certification is legally permitted to produce a certified translation to the satisfaction of courts and other legal authorities. Bear in mind also that legal formats vary widely across nations and local jurisdictions, so you need to seek out legal translation services that will performed by specialized professionals who possess both knowledge of the law applicable in that particular locality and that sort of court. Tomedes offeglobal coverage in legal translation with localized expertise.",
    img_link: "",
  },
  {
    heading: "Secure Legal Document Translation",
    para: "Our global team is trained in the confidentiality requirements in legal translation and processes all such documents with the highest levels of discretion and security. We provide end-to-end encryption for all platforms, as well as NDAs for our project managers and translators.",
    img_link: "",
  },
];

export const FinancialCardData = [
  {
    image: Arabic,
    link: "/recent-translations/english-to-arabic-legal-document-translation.php",
    flagHead2: "English to Arabic Legal Document Translation"
  },
  {
    image: Swedish,
    link: "/recent-translations/swedish-english-legal-document-translation",
    flagHead2: "Swedish English Legal Document Translation"
  },
  {
    flagHead2: "Spanish English Legal Birth Certificate Translation",
    image: Spanish,
    link: "/recent-translations/spanish-english-legal-birth-certificate-translation",
  },
  {
    flagHead2: "English Chinese Legal Translation",
    image: Chinese,
    link: "/recent-translations/english-chinese-legal-translation",
  },
  {
    flagHead2: "German English Rush Legal Translation",
    image: German,
    link: "/recent-translations/german-english-legal-translation.php",
  },
];

export const FinancialCardData2 = [
  {
    head: "Notarized Translation",
    image: Notarized,
    link: "/notarized-translation.php",
  },
  {
    head: "Death Certificate Translation",
    image: Death,
    link: "death-certificate-translation.php",
  },
  {
    head: "Birth Certificate Translation",
    image: Birth,
    link: "/birth-certificate-translation.php",
  },
  {
    head: "Certificate Translation",
    image: Certificate,
    link: "/certified-translation.php",
  },
  {
    head: "Patent Translation",
    image: Patent,
    link: "/patent-translation.php",
  },
];
